export const PCS_PER_UNIT: Record<number, number> = {
  1: 10000,
  2: 5000,
  2.5: 4000,
  3: 3000,
  7: 1125,
  15: 500,
  25: 300,
  45: 100,
};

export const extractLeadingNumber = (text: string | undefined): number | null => {
  if (!text) return null;
  const match = text.match(/\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
};

/**
 * pcs / pallet theo SIZE gallon (1 gal, 3 gal, …).
 * Backend đôi khi để `product_name` rỗng nên cần fallback `name`.
 */
export function getPcsPerUnitForSize(size: string | undefined): number | null {
  if (!size) return null;
  const num = extractLeadingNumber(size);
  return num !== null ? PCS_PER_UNIT[num] ?? null : null;
}
